import { render, staticRenderFns } from "./Part-2.vue?vue&type=template&id=62bf1f7f&"
import script from "./Part-2.vue?vue&type=script&lang=js&"
export * from "./Part-2.vue?vue&type=script&lang=js&"
import style0 from "./Part-2.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports